import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";

import {
  BadgeIndianRupee,
  FileCheck2,
  FileText,
  Image,
  Images,
  LayoutDashboard,
  LogOut,
  Menu,
  MessageSquare,
  Newspaper,
  School,
  Video,
  X,
} from "lucide-react";

import { useAdminAuth } from "../context/AdminAuthContext";

const links = [
  {
    to: "/admin",
    label: "Dashboard",
    icon: LayoutDashboard,
    end: true,
  },
  {
    to: "/admin/banners",
    label: "Banners",
    icon: Image,
  },
  {
    to: "/admin/galleries",
    label: "Photo Gallery",
    icon: Images,
  },
  {
    to: "/admin/video-gallery",
    label: "Video Gallery",
    icon: Video,
  },
  {
    to: "/admin/fee-structure",
    label: "Fee Structure",
    icon: BadgeIndianRupee,
  },
  {
    to: "/admin/mandatory-disclosures",
    label: "Mandatory Disclosure",
    icon: FileText,
  },
  {
    to: "/admin/cbse-details",
    label: "CBSE Details",
    icon: School,
  },
  {
    to: "/admin/transfer-certificates",
    label: "Transfer Certificates",
    icon: FileCheck2,
  },
  {
    to: "/admin/enquiries",
    label: "Enquiries",
    icon: MessageSquare,
  },
  {
    to: "/admin/news",
    label: "News",
    icon: Newspaper,
  },
];

export default function AdminLayout() {
  const { logout } = useAdminAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="admin-shell">
      <aside
        className={`admin-sidebar ${
          open ? "is-open" : ""
        }`}
      >
        <div className="admin-brand">
          <div>
            <small>ST. XAVIER'S BELA</small>
            <strong>Admin Panel</strong>
          </div>

          <button
            type="button"
            className="admin-icon-btn mobile-only"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            <X size={20} />
          </button>
        </div>

        <nav className="admin-nav">
          {links.map(
            ({
              to,
              label,
              icon: Icon,
              end,
            }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                onClick={() =>
                  setOpen(false)
                }
                className={({ isActive }) =>
                  isActive ? "active" : ""
                }
              >
                <Icon size={18} />
                {label}
              </NavLink>
            )
          )}
        </nav>

        <div className="admin-profile">
          <button
            type="button"
            onClick={logout}
          >
            <LogOut size={17} />
            Logout
          </button>
        </div>
      </aside>

      {open && (
        <button
          type="button"
          className="admin-overlay"
          onClick={() => setOpen(false)}
          aria-label="Close menu overlay"
        />
      )}

      <div className="admin-main">
        <header className="admin-header">
          <button
            type="button"
            className="admin-icon-btn mobile-only"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={21} />
          </button>

          <div>
            <small>Administration</small>
            <h1>
              St. Xavier's Public School Bela
            </h1>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}